
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/si-vermoegen1",
      function () {
        return require("private-next-pages/si-vermoegen1.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/si-vermoegen1"])
      });
    }
  